// @core/api/endpoints/team/create_team_ownership_transfer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTeamOwnershipTransferRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Request team ownership transfer
 * Initiates a request to transfer team ownership to another member. The recipient must accept the transfer.
 */
export async function CreateTeamOwnershipTransfer(
  team_id: string,
  data: CreateTeamOwnershipTransferRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/ownership-transfers`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
